export default __webpack_public_path__ + "static/media/chathq-logo.64737bde.png";